import { toPlainText } from 'next-sanity'
import { ReactNode } from 'react'

import { Image } from 'src/components/atoms/Image'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { HeroCtaContainer } from './HeroCtaContainer'
import { HeroTitle, HeroTitleTypography } from './HeroTitleTypography'
import {
  HeroRebrandLayout,
  HeroRebrandLayoutProps
} from './layouts/HeroRebrandLayout'
import { BackgroundPattern, HeroBackgroundPattern } from './types'

type ColourAndImageHeroRebrandProps = {
  title: HeroTitle
  eyebrow?: string
  intro?: string
  ctas?: ReactNode
  imageUrl?: string
  layout: HeroBackgroundPattern
  unified?: boolean
  mode?: HeroRebrandLayoutProps['mode']
  pattern: BackgroundPattern
  darkHeader?: boolean
}

const ColourAndImageHeroRebrand = ({
  title,
  ctas,
  eyebrow,
  imageUrl,
  intro,
  layout,
  unified,
  mode,
  pattern,
  darkHeader
}: ColourAndImageHeroRebrandProps) => {
  return (
    <HeroRebrandLayout
      darkHeader={darkHeader}
      mode={mode}
      layout={layout}
      unified={unified}
      pattern={pattern}
    >
      <div className='flex flex-col-reverse md:flex-row pb-15 md:py-15 items-center gap-6 md:gap-3'>
        <div className='hero-text-content flex-1 flex flex-col w-full items-center md:items-baseline'>
          {eyebrow ? (
            <TypographyRebrand variant='eyebrow'>{eyebrow}</TypographyRebrand>
          ) : null}
          <HeroTitleTypography title={title} variant='h2' />
          {intro ? (
            <TypographyRebrand variant='introduction'>
              {intro}
            </TypographyRebrand>
          ) : null}
          {ctas ? <HeroCtaContainer>{ctas}</HeroCtaContainer> : null}
        </div>
        {imageUrl ? (
          <div className='md:flex-1 w-full flex relative h-60 md:h-80 lg:h-125'>
            <Image
              className='rounded-xl object-cover'
              alt={typeof title === 'string' ? title : toPlainText(title)}
              src={imageUrl}
              fill
            />
          </div>
        ) : null}
      </div>
    </HeroRebrandLayout>
  )
}

export default ColourAndImageHeroRebrand
